(function () {
  function initForm(form) {
    if (form.dataset.arfInit) return;
    form.dataset.arfInit = '1';
    var stars = form.querySelectorAll('.arf__star');
    var ratingInput = form.querySelector('input[name=rating]');
    function setRating(v) { ratingInput.value = v; stars.forEach(function (s) { s.classList.toggle('is-on', parseInt(s.dataset.val, 10) <= v); }); }
    stars.forEach(function (s) { s.addEventListener('click', function () { setRating(parseInt(s.dataset.val, 10)); }); });
    var params = new URLSearchParams(location.search);
    var ph = params.get('product');
    if (ph) { var sel = form.querySelector('select[name=product_handle]'); if (sel) sel.value = ph; }
    var msg = form.querySelector('.arf__msg');
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var action = form.getAttribute('data-action');
      if (!action) { msg.textContent = 'Review form is not connected yet.'; msg.className = 'arf__msg arf__msg--err'; return; }
      if (!ratingInput.value) { msg.textContent = 'Please choose a star rating.'; msg.className = 'arf__msg arf__msg--err'; return; }
      var prodSel = form.querySelector('select[name=product_handle]');
      if (prodSel && !prodSel.value) { msg.textContent = 'Please choose which product you are reviewing.'; msg.className = 'arf__msg arf__msg--err'; return; }
      var bodyEl = form.querySelector('textarea[name=body]');
      if (bodyEl && bodyEl.value.length > 2000) { msg.textContent = 'Please keep your review under 2000 characters.'; msg.className = 'arf__msg arf__msg--err'; return; }
      var btn = form.querySelector('button[type=submit]'); btn.disabled = true; var old = btn.textContent; btn.textContent = 'Submitting…';
      fetch(action, { method: 'POST', body: new FormData(form) })
        .then(function (r) { return r.json().catch(function () { return { ok: r.ok }; }); })
        .then(function (res) {
          if (res && (res.ok || res.success)) {
            form.reset(); setRating(0);
            if (res.discount) {
              msg.innerHTML = 'Thanks! Your review was submitted and will appear once approved.<br><strong>Here is 15% off your next order: ' + res.discount + '</strong><br><span class="arf__msg-note">Copy this code now. It won\'t be shown again.</span>';
            } else {
              msg.textContent = 'Thanks! Your review was submitted and will appear once approved.';
            }
            msg.className = 'arf__msg arf__msg--ok';
          } else { msg.textContent = (res && res.error) || 'Something went wrong. Please try again.'; msg.className = 'arf__msg arf__msg--err'; }
        })
        .catch(function () { msg.textContent = 'Network error. Please try again.'; msg.className = 'arf__msg arf__msg--err'; })
        .finally(function () { btn.disabled = false; btn.textContent = old; });
    });
  }
  function init() { document.querySelectorAll('.arf').forEach(initForm); }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
